module.exports = "https://static.wmbcdn.com/uniweb/images/89f618ee9c8e096604723852d1f6c39f.svg";